import BaseModel from '../../../base';
// eslint-disable-next-line import/no-named-as-default
import Tournament from '../../index';

import TournamentStage from '../index';

export default class TournamentStageGroup extends BaseModel {
  constructor(group = {}, url) {
    super(group, url);

    this.name = group.name || '';
    this.description = group.description || '';

    this.tournament_stage_id = group.tournament_stage_id;
    this.is_default_receptions = group.is_default_receptions ?? false;
    this.tournament_stage = new TournamentStage(group.tournament_stage || {}, 'tournament-stage');

    this.tournament = new Tournament(group.tournament, 'tournament');

    this.users_count = group.users_count || 0;
    this.teams_count = group.teams_count || 0;
  }

  get displayName() {
    const { name: stageName } = this.tournament_stage;
    return [
      this.name,
      ...stageName ? [`(${stageName})`] : [],
    ].join(' ');
  }
}
